import React from "react";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { Select } from "../../components/Select";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "@styles/integrations.module.scss"
import { Context } from "pages/Integrations";

export default class EcleticaDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      token: "",
      store: "",
      network: "",
      environment: "PRODUCTION",
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "external_credentials"
    );
    const ecleticaConfigs = externalCredentials.ecletica || {};

    if (Object.keys(ecleticaConfigs).length > 0) {
      this.setState({
        token: ecleticaConfigs.token,
        store: ecleticaConfigs.store,
        network: ecleticaConfigs.network,
        environment: ecleticaConfigs.environment,
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { environment, token, network, store } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "external_credentials"
        );
      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        {
          ...externalCredentials,
          ecletica: {
            environment,
            token,
            network,
            store,
          },
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, loadingPage, environment, token, network, store } =
      this.state;
    const { visible, onClose } = this.props;

    const isValid = environment && token && network && store;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Eclética"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mb-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environment === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environment === "SANDBOX",
                },
              ]}
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Token"
              value={token}
              onChange={(e) => this.setState({ token: e.target.value })}
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Rede"
              value={network}
              onChange={(e) => this.setState({ network: e.target.value })}
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Loja"
              value={store}
              onChange={(e) => this.setState({ store: e.target.value })}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
